import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService, WindowService } from 'src/app/store/services';
import { from, Subject, takeUntil } from 'rxjs';
import { AngularStripeService } from '@fireflysemantics/angular-stripe-service';

@Component({
    selector: 'app-payment-plan-dialog',
    templateUrl: './payment-plan-dialog.component.html',
    styleUrls: ['./payment-plan-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentPlanDialogComponent implements OnInit, OnDestroy {
    @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;

    stripe;
    card: any;
    error: string;
    cardHandler = this.onChange.bind(this);
    customerId: string;
    ephemeralKeySecret: string;
    publishableKey: string;
    setUpIntentClientSecret: string;
    isShowStripe: boolean;
    private destroyed$ = new Subject<void>();

    constructor(
        public dialogRef: MatDialogRef<PaymentPlanDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private window: WindowService,
        private apiService: ApiService,
        private cdRef: ChangeDetectorRef,
        private stripeService: AngularStripeService,
    ) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    creditCard(): void {
        if (this.isShowStripe) {
            this.activateStripeForm();
            return;
        }

        this.apiService
            .retrieveTokenToPerformPayment({
                stripeVersion: '',
                email: this.data.email,
                deviceId: this.data.deviceID,
            })
            .pipe(takeUntil(this.destroyed$))
            .subscribe((res) => {
                this.isShowStripe = true;
                this.cdRef.markForCheck();
                this.customerId = res.customerId;
                this.ephemeralKeySecret = res.ephemeralKeySecret;
                this.publishableKey = res.publishableKey;
                this.setUpIntentClientSecret = res.setUpIntentClientSecret;

                // drawing stripe UI
                this.stripeService.setPublishableKey(res.publishableKey).then((stripe) => {
                    this.stripe = stripe;
                    const elements = stripe.elements();
                    this.card = elements.create('card');
                    this.card.mount(this.cardInfo.nativeElement);
                    this.card.addEventListener('change', this.cardHandler);

                    // this.cdRef.markForCheck();
                });
            });
    }

    paypal(): void {
        this.window.getWindow.location.href = 'https://www.paypal.com/';
    }

    onCancel(): void {
        this.isShowStripe = false;
    }

    // STRIPE
    onChange({ error }) {
        if (error) {
            this.error = error.message;
        } else {
            this.error = null;
        }
        this.cdRef.detectChanges();
    }

    activateStripeForm() {
        from(
            this.stripe.confirmCardSetup(this.setUpIntentClientSecret, {
                payment_method: {
                    card: this.card,
                },
            }),
        )
            .pipe(takeUntil(this.destroyed$))
            .subscribe((res: any) => {
                if (res && res.setupIntent?.status === 'succeeded') {
                    this.dialogRef.close(true);
                }
            });
    }
}
